import { internalGet } from './index';
import qs from 'qs';

export const getToRequestAccess = ({ filters, skip }) => {
  if (skip) {
    return Promise.resolve(null);
  }
  return internalGet(`/to-request-access?${qs.stringify(filters)}`);
};

export const getToRequestAccessById = ({ toRequestAccessId }) => {
  return internalGet(`/to-request-access/${toRequestAccessId}`);
};
